export default "__VITE_ASSET__D$zP148d__"